let getTokenFunction: (() => Promise<string | null>) | null = null;

export function setAuth0TokenGetter(fn: () => Promise<string | null>) {
  getTokenFunction = fn;
}

export async function getAuth0Token(): Promise<string | null> {
  if (!getTokenFunction) {
    return null;
  }

  try {
    return await getTokenFunction();
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error("[Auth0Token] Failed to get access token:", error);
    }
    return null;
  }
}
